(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-description"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const openById = (id) => {
      if (!id) return;
      const host = document.getElementById(id);
      if (!host || !host.closest('.product-collapsible-section')) return;
      const disclosure = host.matches('details-disclosure')
        ? host
        : host.closest('details-disclosure') || host.querySelector('details-disclosure');
      const details = disclosure && disclosure.querySelector('details');
      if (!disclosure || !details || details.open) return;
      if (typeof disclosure.open === 'function') {
        disclosure.open();
      } else {
        details.open = true;
      }
    };

    document.addEventListener('click', (event) => {
      const badge = event.target.closest(
        '.stamped-product-reviews-badge, .stamped-badge, a[href*="stamped-main-widget"]'
      );
      if (badge) openById('reviews');

      const link = event.target.closest('a[href^="#"]');
      if (!link) return;
      const href = link.getAttribute('href');
      if (!href || href === '#') return;
      openById(href.slice(1));
    }, true);

    if (window.location.hash) {
      openById(window.location.hash.slice(1));
    }

    const refreshStamped = () => {
      const stamped = window.StampedFn;
      if (!stamped) return;
      if (typeof stamped.reloadUGC === 'function') {
        stamped.reloadUGC();
      } else if (typeof stamped.initializeWidgets === 'function') {
        stamped.initializeWidgets();
      }
    };

    document.querySelectorAll('[data-reviews-disclosure]').forEach((details) => {
      details.addEventListener('toggle', () => {
        if (details.open) refreshStamped();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
